import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "login" };
const _hoisted_2 = {
    key: 0,
    class: "mask flexColumn-alc flex-jcc"
};
import { computed, reactive, ref, provide, onUnmounted, onMounted, nextTick } from 'vue';
import loginPhone from './module/login_phone.vue';
import loginInfo from './module/login_info.vue';
import loginForgetPassword from './module/login_forgetPassword.vue';
import { useStore } from 'vuex';
import emitter from '@/utils/eventBus';
import loginRegister from './module/login_register.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login',
    setup(__props) {
        const store = useStore();
        onMounted(() => {
            emitter.on('eidtUserInfo', () => {
                setTimeout(() => {
                    loginStatus.value = 'info';
                }, 50);
            });
            loginStatus.value = 'phone';
        });
        onUnmounted(() => {
            emitter.off('eidtUserInfo');
        });
        const loginForgetPasswordRef = ref();
        const handleForgetPassword = (mobile) => {
            loginStatus.value = 'forgetPassword';
            nextTick(() => {
                var _a;
                (_a = loginForgetPasswordRef.value) === null || _a === void 0 ? void 0 : _a.setMobile(mobile);
            });
        };
        const showMask = computed(() => {
            if (store.state.loginStatus)
                loginStatus.value = 'phone';
            return store.state.loginStatus;
        });
        const closeMask = () => {
            store.commit('setLoginStatus', { status: false });
        };
        const loginStatus = ref('phone'); // 登录状态 phone填写手机号 forgetPassword忘记密码 register注册 info填写用户信息
        const form = reactive({
            mobile: '' // 手机号
        });
        provide('form', form);
        // 登录成功
        const loginSuccess = async (res) => {
            try {
                await store.dispatch('getUserInfo');
            }
            catch (error) { }
            if (res === null || res === void 0 ? void 0 : res.newRegister) {
                // 新用户
                loginStatus.value = 'info';
            }
            else {
                store.commit('setLoginStatus', { status: false });
            }
            store.commit('setHistroyList');
            store.commit('setDrawHistroyList');
            store.commit('setSimpleList');
        };
        // 返回
        const back = () => {
            loginStatus.value = 'phone';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_Transition, { name: "mask-fade" }, {
                    default: _withCtx(() => [
                        (showMask.value)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                                (loginStatus.value === 'phone')
                                    ? (_openBlock(), _createBlock(loginPhone, {
                                        key: 0,
                                        class: "l_box",
                                        onClose: closeMask,
                                        onLoginSuccess: loginSuccess,
                                        onForgetPassword: handleForgetPassword,
                                        onRegister: _cache[0] || (_cache[0] = ($event) => (loginStatus.value = 'register'))
                                    }))
                                    : _createCommentVNode("", true),
                                (loginStatus.value === 'forgetPassword')
                                    ? (_openBlock(), _createBlock(loginForgetPassword, {
                                        key: 1,
                                        ref_key: "loginForgetPasswordRef",
                                        ref: loginForgetPasswordRef,
                                        class: "l_box",
                                        onBack: back
                                    }, null, 512))
                                    : _createCommentVNode("", true),
                                (loginStatus.value === 'register')
                                    ? (_openBlock(), _createBlock(loginRegister, {
                                        key: 2,
                                        class: "l_box",
                                        onBack: back,
                                        onClose: closeMask
                                    }))
                                    : _createCommentVNode("", true),
                                (loginStatus.value === 'info')
                                    ? (_openBlock(), _createBlock(loginInfo, {
                                        key: 3,
                                        class: "l_box",
                                        onClose: closeMask
                                    }))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
